// @flow
import { connect } from 'react-redux';

import { fetchTeamResultStart } from 'actions/team/teamResultActions';
import TeamResult, { type DispatchProps, type StateProps } from 'components/team/TeamResult';
import { selectCompetitionLink } from 'selectors/selectSettings';
import type { DispatchType, StateType } from 'types/Actions';

const mapStateToProps = (state: StateType): StateProps => ({
  competitionIds: state.pageListState.competitions,
  title: state.pageListState.title,
  clubId: state.settingsState.club_id,
  clubName: state.settingsState.title,
  competitions: state.teamResultState.competitions,
  status: state.teamResultState.status,
  rejoignez_nous: state.settingsState.rejoignez_nous,
  rejoignez_nous_background: state.settingsState.rejoignez_nous_background,
  competitionLink: selectCompetitionLink(state),
  historique: state.pageListState.competitions_saisons,
  historiqueResults: state.teamResultState.historique,
  currentSeason: state.seasonsState.lastSeason,
  seasons: state.seasonsState.seasons,
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchProps => ({
  fetchTeamResultStart: (clubId: string, competitions: string[] | null, season?: string) =>
    dispatch(fetchTeamResultStart(clubId, competitions, season)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamResult);
